import { fmtMoney } from "@/lib/assessment";

export default function GstNote({ pricing, suffix = "" }) {
  if (!pricing) return null;
  return (
    <p className="text-xs text-slate-500 mt-1.5">
      {fmtMoney(pricing.base_aud, "AUD")} + 10% GST{" "}
      {fmtMoney(pricing.gst_aud, "AUD")} ={" "}
      <span className="font-medium text-slate-700">
        {fmtMoney(pricing.total_aud, "AUD")} incl. GST{suffix}
      </span>
    </p>
  );
}
